import {getCalendarInput, getTimeFormat} from "./Calendar-util";


const countryLocaleMap = {
    AU: 'en-AU',
    GB: 'en-GB',
    NZ: 'en-NZ',
    SG: 'en-SG',
}

/**
 * @param {string} countryCode
 * @return {string}
 */
function getLocaleString(countryCode) {

    const locale = countryLocaleMap[countryCode] || "";
    return locale.toLowerCase();
}

/**
 * @return {string}
 */
function getCountryCode () {

    return sessionStorage.getItem('country_iso2')||"";
}

/**
 * @typedef {Object} UserSetting
 * @property {string} language
 * @property {string} countryCode
 * @property {string} locale
 * @property {string} timeZone
 * @property {string} timeFormat
 * @property {boolean} hour12
 * @property {CalendarInput} calendarInput
 * @property {"timeGridWeek" | "timeGridDay"} calendarInitialView
 * @property {string} calendarDayViewStartTime
 * @property {"1" | "2"} calendarDayViewStartTime
 */

/**
 *
 * @return {UserSetting}
 */
export function getUserSetting() {

    const countryCode = getCountryCode();
    const locale = getLocaleString(countryCode);
    const timeFormat = getTimeFormat(locale);
    const calendarInput = getCalendarInput(locale);
    const hour12 = calendarInput.eventTimeInput.hour12;

    return {
        language: "en",
        countryCode: countryCode,
        locale: locale,
        timeZone: "UTC",
        timeFormat: timeFormat,
        hour12: hour12,
        calendarInput: calendarInput,
        calendarInitialView: "timeGridWeek",
        calendarDayViewStartTime: "09:00:00",
        calendarFilterViewMode:"2",
    };
}